import React from 'react';
import { Form, Col, Row, Button, Spinner, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios, { AxiosRequestConfig } from 'axios';
import BootstrapTable from 'react-bootstrap-table-next';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const lineItemColumns = [
    {
        text:'Item #',
        dataField: 'DisplayID',
        headerStyle: (colum, colIndex) => {
            return { width: '250px', textAlign: 'center' };
        }
    },
    {
        text: 'Item Description',
        dataField: 'ItemDescription',
        headerStyle: (colum, colIndex) => {
            return { textAlign: 'center' };
        }
    },
    {
        text: 'Quantity',
        dataField: 'ItemQuantity',
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    }];
const upcomingColumns = [
    {
        dataField: 'Date',
        text: 'Date',
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    },
    {
        dataField: 'Technician',
        text: 'Technician',
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    }];
const columns = [
    {
        dataField: 'VisitDate',
        text: 'Date',
        formatter: dateFormat,
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    },
    {
        dataField: 'Technician',
        text: 'Technician',
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    },
    {
        dataField: 'ServiceNotes',
        text: 'Service Notes',
        headerStyle: (colum, colIndex) => {
            return { textAlign: 'center' };
        }
    }];


function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

class GuestViewOrderDetails extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            input: {},
            visits: [],
            selected: [],
            appointments: [],
            relatedFiles:[],
            badLink: false,
            extraData: {
                lineItems: [],
                CallTypeDescription: '',
                EndDate: '',
                displayIDLabel:''
            },
            loading: false
        };

        this.downloadSelected = this.downloadSelected.bind(this);
        this.showButton = this.showButton.bind(this);
        /*this.createSelectItems = this.createSelectItems.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);*/
    }

    componentDidMount() {

        let params = new URLSearchParams(window.location.search);
        let guid = params.get('id');
        axios.get(`${Constants.apiURL}/api/Guest/GetOrderDetails`, {
            params: {
                id: guid
            }
        }).then(response => {
            if (response.data) {
                let extraData = JSON.parse(response.data.order);
                let notes = [];
                let appointments = [];
                let relatedFiles = [];

                if (extraData.lineItems == null) {
                    extraData.lineItems = [];
                }
                if (extraData.SubType == 'ServiceCall') {
                    extraData.displayIDLabel = 'Service Call ID';
                }
                if (extraData.SubType == 'JobCost') {
                    extraData.displayIDLabel = 'Project Number';
                    extraData.CallTypeDescription = 'Project';
                }
                if (extraData.EndDate != null) {
                    extraData.displayIDLabel = 'Contract Number';
                    extraData.EndDate = moment(extraData.EndDate).format('MM/DD/YYYY')
                }
                if (extraData.OrderType == 'Parts') {
                    extraData.displayIDLabel = 'Parts Order Number';
                    let shippingAddress = extraData.Address1.trim() +
                        (extraData.Address2.trim() == '' ? '' : '\n' + extraData.Address2.trim()) +
                        '\n' + extraData.City.trim() + ', ' + extraData.State.trim() + ' ' + extraData.Zip.trim();
                    extraData.ShippingAddress = shippingAddress;
                }

                if (response.data.notes) {
                    notes = JSON.parse(response.data.notes);
                }
                if (response.data.appointments) {
                    appointments = JSON.parse(response.data.appointments);
                }
                if (response.data.relatedFiles) {
                    relatedFiles = JSON.parse(response.data.relatedFiles);
                }

                this.setState({
                    extraData: extraData,
                    visits: notes,
                    appointments: appointments,
                    relatedFiles: relatedFiles
                });
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ badLink: true, loading: false });
        });/**/
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    }


    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadSelected}>
                Download Selected
            </Button>
        }
    }

    downloadSelected(event) {

        if (this.state.selected.length == 0) { return; }
        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Guest/DownloadSiteVisits`, this.state.selected, {
            'headers': {
               'content-type': 'application/json'
            },
            responseType: 'blob'
        }).then(response => {
            this.setState({ loading: false });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: response.headers['content-type'] }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleSelect = (row, isSelect) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = [...this.state.selected, row];
        } else {
            allow = false;
           CurrentSelected = this.state.selected.filter(x => x !== row);
        }
        this.state.selected = CurrentSelected;
    }

    handleSelectAll = (isSelect, rows) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = rows;
        } else {
            CurrentSelected = [];
        }
        this.state.selected = CurrentSelected;
    }

    render() {
        const relatedFilesColumns = [
            {
                text: '',
                dataField: 'x',
                formatter: (cell, row) => {
                    return <Button style={{ backgroundColor: '#1F419B', width: '100%' }} onClick={(event) => {

                        axios.get(`${Constants.apiURL}/api/Guest/DownloadFile`, {
                            params: {
                                user: this.state.user.username,
                                id: row.DocLinkID
                            },
                            responseType: "blob"
                        }).then(response => {
                            this.setState({ loading: false });

                            let blob = new Blob([response.data], { type: "application/pdf" }),
                                downloadUrl = window.URL.createObjectURL(blob),
                                filename = "",
                                disposition = response.headers["content-disposition"];

                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                                    matches = filenameRegex.exec(disposition);

                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, "");
                                }
                            }
                            else {
                                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                                return;
                            }

                            let a = document.createElement("a");
                            if (typeof a.download === "undefined") {
                                window.location.href = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        }).catch((response) => {
                            // ? Show to user that request is failed
                            this.setState({ errors: [response] })
                            this.setState({ loading: false });
                            console.log('request failed', response)
                        });
                    }}>Download</Button>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Date Uploaded',
                dataField: 'CreatedDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Type',
                dataField: 'DocumentType',
                headerStyle: (colum, colIndex) => {
                    return { width: '200px', textAlign: 'center' };
                }
            },
            {
                text: 'Equipment Serial Number(s)',
                dataField: 'MachineSerials',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center' };
                },
                formatter: (cell, row) => {
                    let machines = cell.split(',');
                    return machines.map((item) => {
                        return <div>
                            <span>{item}</span><br />
                        </div>;
                    });
                }
            },
            {
                text: 'Report Findings?',
                dataField: 'ReviewRequired',
                headerStyle: (colum, colIndex) => {
                    return { width: '160px', textAlign: 'center', wordBreak: 'break-all' };
                },
                style: (cell, row, rowIndex, colIndex) => {
                    return { wordBreak: 'break-all' };
                },
                formatter: (cell, row) => {
                    return cell == null || cell == false ? "No" : "Yes";
                }
            }];
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll,
        };
        return (
            <div className="site_visit">
                <Modal
                    show={this.state.badLink}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body>This link has expired. To view this order and more, register for a Boland Client Portal account&nbsp;
                        <Link to={{
                            pathname: "/register"
                        }} style={{ marginTop: '10px' }}>here</Link>
                </Modal.Body>
            </Modal>
                <GuestSiteMenu currentPage='guestOrderDetails' />
                <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Order Details</Form.Label>
                <Form as={Row} style={{margin:5}}>
                    <Col md={6}>
                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={2} >Created Date</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="CreatedDate" value={moment(this.state.extraData.CreatedDate).format('MM/DD/YYYY')} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={2}>Status</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="status" value={this.state.extraData.Status} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" hidden={this.state.extraData.SubType != 'ServiceCall'}>
                            <Form.Label column md={2}>Completion Date</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="completionDate" value={this.state.extraData.CompletionDate == null ? '' : moment(this.state.extraData.CompletionDate).format('MM/DD/YYYY')} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={2}>Order Number</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="orderNum" value={this.state.extraData.OrderNumber} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={2}>PO Number</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="poNumber" value={this.state.extraData.PurchaseOrder} disabled />
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col md={6} hidden={this.state.extraData.OrderType == 'Parts'}>
                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={2}>Order Type</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="orderType" value={this.state.extraData.OrderType} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" hidden={this.state.extraData.OrderType != 'Service'}>
                            <Form.Label column md={2}>Service Type</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="serviceType" value={this.state.extraData.CallTypeDescription} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={2}>{this.state.extraData.displayIDLabel}</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="displayID" value={this.state.extraData.DisplayID} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={2}>Building Name</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="buildingName" value={this.state.extraData.BuildingName} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={2}>Description</Form.Label>
                            <Col md={10}>
                                <Form.Control as="textarea" rows={3} name="orderDescription" value={this.state.extraData.OrderDescription} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" hidden={this.state.extraData.OrderType != 'Contract'}>
                            <Form.Label column md={2}>Expiration Date</Form.Label>
                            <Col md={10}>
                                <Form.Control type="input" name="expirationDate" value={this.state.extraData.EndDate} disabled />
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col md={6} hidden={this.state.extraData.OrderType != 'Parts'}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={3}>Order Type</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" name="displayID" value={this.state.extraData.OrderType} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={3}>{this.state.extraData.displayIDLabel}</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" name="displayID" value={this.state.extraData.DisplayID} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={3}>Shipping Address</Form.Label>
                            <Col md={9}>
                                <Form.Control as="textarea" rows={4} name="orderType" value={this.state.extraData.ShippingAddress} disabled />
                            </Col>
                        </Form.Group>
                    </Col>
                </Form>
                <Form.Group as={Row} className="mb-3" style={{marginLeft:5}}>
                    <Col md="auto" style={{ paddingLeft: 0 }}>
                        <Button style={{ width: '200px', backgroundColor: '#00973A' }} as={Link} to={{
                            pathname: "/order_inquiry",
                            state: {
                                data: this.state.extraData
                            }
                        }} >Order Inquiry</Button>
                    </Col>
                    <Col md="auto" style={{ paddingLeft: 0 }} hidden={this.state.extraData.OrderType == 'Parts'}>
                        <Button style={{ width: '200px', backgroundColor: '#1F419B' }} as={Link} to={{
                            pathname: "/scheduling_request",
                            state: {
                                data: this.state.extraData
                            }
                        }} >Scheduling Request</Button>
                    </Col>
                    <Col style={{ width:'100%' }}/>
                </Form.Group>
                <div style={{width:'500px'}} hidden={this.state.extraData.SubType != 'ServiceCall' && this.state.extraData.OrderType != 'Contract'}>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Upcoming Appointments</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="Id"
                        wrapperClasses="table-responsive"
                        data={this.state.appointments}
                        columns={upcomingColumns}
                        onTableChange={this.onTableChange}
                        noDataIndication={() =>
                            <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                No upcoming appointments for this order.
                            </Form.Label>}
                        striped
                        hover
                    />
                </div>
                <div style={{ width: '840px' }} hidden={this.state.extraData.SubType != 'ServiceCall'}>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Related Files</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="DocumentID"
                        wrapperClasses="table-responsive"
                        data={this.state.relatedFiles}
                        columns={relatedFilesColumns}
                        onTableChange={this.onTableChange}
                        noDataIndication={() =>
                            <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                No related files for this order.
                            </Form.Label>}
                        striped
                        hover
                    />
                </div>
                <div hidden={this.state.extraData.SubType != 'ServiceCall' && this.state.extraData.OrderType != 'Contract'}>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Completed Site Visits</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="Id"
                        selectRow={selectRow}
                        wrapperClasses="table-responsive"
                        data={this.state.visits}
                        columns={columns}
                        onTableChange={this.onTableChange}
                        noDataIndication={() =>
                            <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                Service notes for this call have not yet been completed. If you have questions on this order, please submit an order inquiry&nbsp;
                                <Link to={{
                                    pathname: '/order_inquiry',
                                    state: {
                                        data: this.state.extraData
                                    }
                                }}>here</Link>
                            </Form.Label>}
                        striped
                        hover
                    />
                        {this.showButton()}
                </div>
                <div style={{ width: '50%' }} hidden={this.state.extraData.OrderType != 'Parts'}>
                    <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">Item Details</Form.Label>
                    <BootstrapTable
                        bootstrap4
                        remote
                        keyField="DisplayID"
                        wrapperClasses="table-responsive"
                        data={this.state.extraData.lineItems}
                        columns={lineItemColumns}
                        onTableChange={this.onTableChange}
                        striped
                        hover
                    />
                </div>
            </div>
        );
    }
}

export default GuestViewOrderDetails;